import Auth from "@aws-amplify/auth";
import store from "@/store";
import userService from "@/services/repositories/userRepository";
async function generateUser({ cache = false } = {}) {
  if (
    !store.getters["getOrganization"] ||
    !store.getters["getOrganization"]._id
  ) {
    return;
  }
  let user = await Auth.currentAuthenticatedUser({ bypassCache: !cache }).catch(
    err => {
      console.error("[AUTH]", err);
      Promise.resolve(null);
    }
  );
  if (user) {
    store.commit("setAWSUser", user);
    let doc_user = await userService.get().catch(err => {
      Promise.resolve(null);
    });
    if (doc_user) {
      store.commit("setUser", doc_user);
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  } else {
    //TODO - clear cookies
    // Auth.signOut();
    store.commit("setUser", null);
    store.commit("setAWSUser", null);
    clear();
    return Promise.resolve(false);
  }
}
export default generateUser;
let domain = window.location.hostname;
if (process.env.VUE_APP_AUTH_COOKIE_DOMAIN != undefined) {
  domain = process.env.VUE_APP_AUTH_COOKIE_DOMAIN;
}
// eslint-disable-next-line no-unused-vars
const clear = () => {
  var cookies = document.cookie.split(";");
  cookies.forEach(cookie => {
    let s = String(cookie).split(".");
    if (`${s[0]}`.trim() != "CognitoIdentityServiceProvider") {
      return;
    }
    console.log(
      domain,
      s[0],
      "CognitoIdentityServiceProvider",
      `${s[0]}`.trim() != "CognitoIdentityServiceProvider"
    );
    document.cookie = `${cookie}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${domain}`;
    document.cookie = `${cookie}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  });
};
